import React from 'react';
import classnames from 'classnames/bind';
import Label from '../Label';
import FieldErrors from '../FieldErrors';

import styles from './styles.scss';

export default class SelectBox extends React.Component {

    _getClassNames() {
        const cx = classnames.bind(styles);

        return cx({
            'select': true,
            'select--error': this.props.meta && this.props.meta.invalid
        });
    }

    render() {

        // Filter out props supplied by react-redux-form Field component
        const { containerClassName, label, required, input, meta, ...allProps } = this.props;

        const inputId = `${input.name}_input`;

        return (
            <div className={containerClassName}>
                <Label text={label} htmlFor={inputId} required={required}>
                    <div className={this._getClassNames()}>
                        <select
                            {...input}
                            {...allProps}
                            id={inputId}
                            aria-required={required}
                        >
                            { this.props.children }
                        </select>
                    </div>
                </Label>

                {meta && meta.touched && meta.error && <FieldErrors errors={meta.error} />}
            </div>
        )
    }
}